"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ui_1 = require("@vidazoo/ui");
var theme = require("./theme.scss");
var utils_1 = require("../../../../utils");
var NameFieldModal = /** @class */ (function (_super) {
    tslib_1.__extends(NameFieldModal, _super);
    function NameFieldModal(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onChange = function (e) {
            var _a;
            _this.setState((_a = {},
                _a[e.target.name] = utils_1.normalizeEventValue(e),
                _a));
        };
        _this.onChangeShareBetweenAccounts = function (e) {
            _this.setState({
                shared: e.target.checked
            });
        };
        _this.onClose = function () {
            var onClose = _this.props.onClose;
            _this.setState(_this.initialState);
            onClose();
        };
        _this.onSubmit = function () {
            var onSubmit = _this.props.onSubmit;
            var _a = _this.state, name = _a.name, shared = _a.shared;
            onSubmit({ name: name, shared: shared });
            _this.onClose();
        };
        _this.state = _this.initialState;
        return _this;
    }
    Object.defineProperty(NameFieldModal.prototype, "initialState", {
        get: function () {
            return {
                name: "",
                shared: false
            };
        },
        enumerable: true,
        configurable: true
    });
    NameFieldModal.prototype.render = function () {
        var _a = this.props, onClose = _a.onClose, onSubmit = _a.onSubmit, label = _a.label, submitText = _a.submitText, cancelText = _a.cancelText, allowSharedPresets = _a.allowSharedPresets, others = tslib_1.__rest(_a, ["onClose", "onSubmit", "label", "submitText", "cancelText", "allowSharedPresets"]);
        var name = this.state.name;
        return (React.createElement(ui_1.Modal, tslib_1.__assign({ exitOnClickOutside: true, basic: true, windowClass: theme.modal, onClose: this.onClose }, others),
            React.createElement(ui_1.Form, { onSubmit: this.onSubmit },
                React.createElement(ui_1.Label, { monserrat: true, uppercase: true, spacing: 1.5, weight: 600 }, label),
                React.createElement(ui_1.FormInput, { onChange: this.onChange, value: name, required: true, name: "name", label: "Name", fill: true, className: theme.input }),
                allowSharedPresets &&
                    (React.createElement(ui_1.Switch, { className: theme.switch, name: "shareBetweenAccounts", label: "Share between accounts", checked: this.state.shared, onChange: this.onChangeShareBetweenAccounts, small: true, green: true })),
                React.createElement("div", { className: theme.actions },
                    React.createElement(ui_1.Button, { gray: true, medium: true, onClick: this.onClose }, cancelText),
                    React.createElement(ui_1.Button, { type: "submit", blue: true, medium: true }, submitText)))));
    };
    NameFieldModal.defaultProps = {
        cancelText: "Cancel",
        submitText: "Create Reoprt"
    };
    return NameFieldModal;
}(React.Component));
exports.default = NameFieldModal;
